import i18next from "i18next";
import { Step, StepDivider, StepIcon, StepLabel, Wrapper } from "./style";

const ProgressSteps = ({ currentStep = 2 }) => {
  const { t } = i18next;

  const steps = [
    { id: 1, label: t("flight_selection") },
    { id: 2, label: t("passenger_details") },
    { id: 3, label: t("payment") },
  ];

  return (
    <Wrapper>
      {steps.map((step, index) => (
        <>
          <Step key={step.id} $isActive={currentStep === step.id} $isCompleted={currentStep > step.id}>
            <StepIcon $isActive={currentStep === step.id} $isCompleted={currentStep > step.id}>
              {currentStep > step.id ? "✓" : step.id}
            </StepIcon>
            <StepLabel $isActive={currentStep === step.id}>{step.label}</StepLabel>
          </Step>
          {index < steps.length - 1 && <StepDivider $isCompleted={currentStep > step.id} />}
        </>
      ))}
    </Wrapper>
  );
};

export default ProgressSteps;

